
import "../Gulf_Students/CSS/ThanksPage.css";

const PeerMentorshipSuccess = () => {
    return (
        <>
            <section className="thank-you-page-main-section">
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-md-12 thank-you-page-heading-para-div contact-form-div">
                            <h1>We have received your information.</h1>
                            <h2>Our team will get in touch with you shortly.</h2>
                            <h4>Our team will review your submission and reach out within 24 - 48 hours.</h4>
                            <h4>Please keep an eye on your email and phone during this period.</h4>
                            <h4>If you need immediate assistance, please email us at <a href="mailto:email@example.com"><span><strong>hr@holisticlearningllc.com</strong></span></a> or connect with HR team at <span><strong>+91 72594 10987</strong></span>.</h4>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default PeerMentorshipSuccess